module.exports = __webpack_public_path__ + "img/nunito-sans-v6-latin-regular.59c1b87f.svg";